import {
  G2_OPERATOR_SIGNUP_REQUEST,
  OPERATOR_FILE_UPLOAD_FAILURE,
  OPERATOR_FILE_UPLOAD_REQUEST,
  OPERATOR_FILE_UPLOAD_SUCCESS,
  OPERATOR_SIGN_UP_FAILURE,
  OPERATOR_SIGN_UP_REQUEST,
  OPERATOR_SIGN_UP_SUCCESS,
  UPDATE_OPERATOR_ACCOUNT_DETAILS,
  UPDATE_OPERATOR_ADDRESS_DETAILS,
} from "../constants";

const INITIAL_STATE = {
  isLoading: false,
  operatorAccountDetails: {},
  operatorAddressDetails: {},
  operatorSignUpData: {},
  operatorFileUploadData: {},
  g2OperatorSignupParams: {},
};

const operatorReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_OPERATOR_ACCOUNT_DETAILS:
      return {
        ...state,
        operatorAccountDetails: action.payload,
      };
    case UPDATE_OPERATOR_ADDRESS_DETAILS:
      return {
        ...state,
        operatorAddressDetails: action.payload,
      };
    case OPERATOR_SIGN_UP_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case OPERATOR_SIGN_UP_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case OPERATOR_SIGN_UP_SUCCESS:
      return {
        ...state,
        operatorSignUpData: action.payload,
        isLoading: false,
      };
    case OPERATOR_FILE_UPLOAD_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case OPERATOR_FILE_UPLOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case OPERATOR_FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        operatorFileUploadData: action.payload,
        isLoading: false,
      };
    case G2_OPERATOR_SIGNUP_REQUEST:
      return {
        ...state,
        g2OperatorSignupParams: action.payload,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default operatorReducer;
